<mat-dialog-content>
  <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
    <div matDialogTitle i18n>Download Documents</div>
    <button mat-icon-button class="close"
      [disabled]="downloadInProgress" (click)="this.dialogRef.close()">
      <span class="close"><mat-icon>close</mat-icon></span>
    </button>
  </div>
  <div class="body">
    <div class="file-list">
      <div *ngFor="let file of files" class="file-item" fxLayout="row"
        fxLayoutAlign="space-between center">
        <div class="file-name">{{ file.fileName }}</div>
        <mat-progress-spinner *ngIf="downloadInProgress"
          color="primary" mode="indeterminate">
        </mat-progress-spinner>
        <span *ngIf="!downloadInProgress && !showError" class="icon-wrapper">
          <mat-icon>check</mat-icon>
        </span>
        <span *ngIf="showError" class="icon-wrapper error">
          <mat-icon>error</mat-icon>
        </span>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
  <div>
    <button class="nav-button" mat-button
      [disabled]="downloadInProgress" (click)="dialogRef.close()" fxFlex i18n>
      Done
    </button>
  </div>
</mat-dialog-actions>
